import React, { useState, memo } from "react";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import moment from "moment-jalaali";
import ExcelJS from "exceljs";

const OperatorTicketExport = ({ entities }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {

            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet("operator_ticket");

            sheet.columns = [
                { header: "نام کاربر", key: "full_name", width: 25 },
                { header: "تعداد کل پاسخ", key: "total", width: 18 },
                { header: "راضی", key: "yes_counter", width: 12 },
                { header: "ناراضی", key: "no_counter", width: 12 },
                { header: "بدون نظر", key: "no_ans_counter", width: 12 },
            ];

            sheet.getRow(1).eachCell(cell => {
                cell.font = { size: 15, bold: true };
                cell.alignment = { horizontal: "center", vertical: "center" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCEEFF" } };
            });

            entities.forEach(item => {
                const row = sheet.addRow({
                    full_name: item.full_name,
                    total: item.total,
                    yes_counter: item.yes_counter,
                    no_counter: item.no_counter,
                    no_ans_counter: item.no_ans_counter,
                });
                row.eachCell(cell => {
                    cell.font = { size: 13 };
                    cell.alignment = { horizontal: "center", vertical: "center" };
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `operator_ticket_${moment().unix()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("خطا در ایجاد فایل اکسل:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title="خروجی اکسل">
      <span>
        <IconButton onClick={fetchData} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : <ImportExportIcon />}
        </IconButton>
      </span>
        </Tooltip>
    );
};

export default memo(OperatorTicketExport);
